import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { stateKeys } from '../../constants';
import { useStateControllers } from '../../stateManager';

const noop = () => {};

const key = stateKeys.filterInfo;

const Context = createContext();

export const useFilterHandler = () => useContext(Context);

export const FilterProvider = ({ children, ...props }) => {
  const { value, onChange = noop, defaultValue } = props ?? {};

  const isControlledRef = useRef(Object.hasOwn(props, 'value'));

  const { setValue } = useStateControllers();

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const changeHandler = useCallback(
    (name, value) => {
      const nextValue = hasValue(value) ? value : undefined;

      onChangeRef.current(name, nextValue);

      if (!isControlledRef.current) {
        setValue(key, (prev) => ({ ...prev, [name]: nextValue }));
      }
    },
    [setValue]
  );

  useEffect(() => {
    if (isControlledRef.current) {
      setValue(key, value);
    } else if (defaultValue) {
      setValue(key, defaultValue);
    }
  }, [value, defaultValue, setValue]);

  return <Context.Provider value={changeHandler}>{children}</Context.Provider>;
};

function hasValue(value) {
  const hasStrVal = typeof value === 'string' && value.trim().length > 0;
  const hasArrVal = Array.isArray(value) && value.length > 0;

  return hasStrVal || hasArrVal || value != null;
}
